var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1520_71",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5844 9.12982H11V13.1038H16.5169C16.0026 15.6285 13.852 17.0779 11 17.0779C7.63378 17.0779 4.92209 14.3662 4.92209 10.9999C4.92209 7.63371 7.63378 4.92203 11 4.92203C12.4494 4.92203 13.7584 5.43632 14.787 6.27788L17.7792 3.28566C15.9559 1.69605 13.6182 0.714233 11 0.714233C5.29611 0.714233 0.714294 5.29605 0.714294 10.9999C0.714294 16.7038 5.29611 21.2857 11 21.2857C16.1429 21.2857 20.8182 17.5454 20.8182 10.9999C20.8182 10.3922 20.7247 9.73761 20.5844 9.12982Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1520_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.220703 17.0778V4.922L7.72735 10.9999L-0.220703 17.0778Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1520_71",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 22
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5844 9.12982H11V13.1038H16.5169C16.0026 15.6285 13.852 17.0779 11 17.0779C7.63378 17.0779 4.92209 14.3662 4.92209 10.9999C4.92209 7.63371 7.63378 4.92203 11 4.92203C12.4494 4.92203 13.7584 5.43632 14.787 6.27788L17.7792 3.28566C15.9559 1.69605 13.6182 0.714233 11 0.714233C5.29611 0.714233 0.714294 5.29605 0.714294 10.9999C0.714294 16.7038 5.29611 21.2857 11 21.2857C16.1429 21.2857 20.8182 17.5454 20.8182 10.9999C20.8182 10.3922 20.7247 9.73761 20.5844 9.12982Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1520_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.220703 4.92203L7.72735 11L11.0001 8.14802L22.2209 6.32463V-0.220825H-0.220703V4.92203Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1520_71",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 22
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5844 9.12982H11V13.1038H16.5169C16.0026 15.6285 13.852 17.0779 11 17.0779C7.63378 17.0779 4.92209 14.3662 4.92209 10.9999C4.92209 7.63371 7.63378 4.92203 11 4.92203C12.4494 4.92203 13.7584 5.43632 14.787 6.27788L17.7792 3.28566C15.9559 1.69605 13.6182 0.714233 11 0.714233C5.29611 0.714233 0.714294 5.29605 0.714294 10.9999C0.714294 16.7038 5.29611 21.2857 11 21.2857C16.1429 21.2857 20.8182 17.5454 20.8182 10.9999C20.8182 10.3922 20.7247 9.73761 20.5844 9.12982Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1520_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.220703 17.0779L13.8053 6.32463L17.4988 6.79216L22.2209 -0.220825V22.2207H-0.220703V17.0779Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1520_71",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 22
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5844 9.12982H11V13.1038H16.5169C16.0026 15.6285 13.852 17.0779 11 17.0779C7.63378 17.0779 4.92209 14.3662 4.92209 10.9999C4.92209 7.63371 7.63378 4.92203 11 4.92203C12.4494 4.92203 13.7584 5.43632 14.787 6.27788L17.7792 3.28566C15.9559 1.69605 13.6182 0.714233 11 0.714233C5.29611 0.714233 0.714294 5.29605 0.714294 10.9999C0.714294 16.7038 5.29611 21.2857 11 21.2857C16.1429 21.2857 20.8182 17.5454 20.8182 10.9999C20.8182 10.3922 20.7247 9.73761 20.5844 9.12982Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1520_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2209 22.2207L7.72737 10.9999L5.85724 9.59732L22.2209 4.922V22.2207Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/googleIcon.a639a87379d2253129bdf30acf23f206.svg";
export { ForwardRef as ReactComponent };